import { render, staticRenderFns } from "./InterventionParticipationTypes.vue?vue&type=template&id=35448f70&scoped=true"
import script from "./InterventionParticipationTypes.vue?vue&type=script&lang=js"
export * from "./InterventionParticipationTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35448f70",
  null
  
)

export default component.exports